import type { JSX } from 'react';
import { Input } from '@morph-mapper/types';
import {
  Checkbox,
  LiteralView,
  MultiSelectCreatable,
  NumberInput,
  RadioSelector,
  SingleSelect,
  SingleSelectCreatable,
  TextInput,
  TextSelector,
  MultiSelect,
  CellSelector,
  TextSelectorAdd,
} from './inputs';
import { type InputProps } from './types';

export { Input } from '@morph-mapper/types';
export { useDebouncedDraft } from './hooks/use-debounced-draft';
export const Inputs: Record<Input, (props: InputProps<any>) => JSX.Element> = {
  [Input.Text]: TextInput,
  [Input.Number]: NumberInput,
  [Input.Checkbox]: Checkbox,
  [Input.TextInput]: TextInput,
  [Input.MultiSelectCreatable]: MultiSelectCreatable,
  [Input.TextSelector]: TextSelector,
  [Input.TextSelectorAdd]: TextSelectorAdd,
  [Input.RadioSelector]: RadioSelector,
  [Input.SingleSelect]: SingleSelect,
  [Input.SingleSelectCreatable]: SingleSelectCreatable,
  [Input.Literal]: LiteralView,
  [Input.MultiSelect]: MultiSelect,
  [Input.CellSelector]: CellSelector,
};
